// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1AZ_J","toggle":"styles_toggle__2e_VZ","preview":"styles_preview__3dvsv"};